import { atom, useRecoilState, useRecoilValue, useSetRecoilState } from 'recoil'
import { JobsResponse } from '../hooks/api/useFetchJobs'

const jobsState = atom<JobsResponse>({
  key: 'jobsState',
  default: []
})

export const useJobsState = ()=> useRecoilState(jobsState)
export const useJobsValue = ()=> useRecoilValue(jobsState)
export const useSetJobsState = ()=> useSetRecoilState(jobsState)
